import React from "react";
import Grid from "@mui/material/Grid";
import ProductFilter from "./ProductFilter/ProductFilter";
import OperationalEmployeeFilter from "./UserFilter/OperationalEmployeeFilter";
import DateRangeFilter from "./DateRangeFilter/DateRangeFilter";
import ActivityTypeFilter from "./ActivityTypeFilter/ActivityTypeFilter";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import { MenuItem, Stack } from "@mui/material";
import SubjectFilter from "./SubjectFilter/SubjectFilter";
import ActivityFilterChip from "../../Chip/ActivityFilterChip";
import { BackofficeUser } from "../../../types/BackofficeUser";
import { activityOverviewHeaderStyles } from "./activityOverviewHeaderStyles";

type ActivityOverviewHeaderProps = {
  productFilter: string;
  isDeadlineView?: boolean;
  setProductFilter: (value: string) => void;
  activityTypeFilter: string;
  setActivityTypeFilter: (value: string) => void;
  userFilter: string;
  setUserFilter: (value: string | number) => void;
  timespanFilter: string;
  setTimespanFilter: (value: string) => void;
  setSubjectFilter: (value: string) => void;
  agents: BackofficeUser[];
  openOrDoneFilter?: string | null;
  setOpenOrDoneFilter?: (value: string) => void;
  overdueTotal: number;
  todayTotal: number;
};

const ActivityOverviewHeader = ({
  productFilter,
  isDeadlineView = false,
  setProductFilter,
  activityTypeFilter,
  setActivityTypeFilter,
  userFilter,
  setUserFilter,
  timespanFilter,
  setTimespanFilter,
  setSubjectFilter,
  agents,
  openOrDoneFilter = null,
  setOpenOrDoneFilter = () => {},
  overdueTotal,
  todayTotal,
}: ActivityOverviewHeaderProps) => {
  const showAmount = !["all", "accountManager", "internalLawyer", "externalLawyer"].some(
    (filter) => filter === userFilter
  );

  return (
    <Grid
      container
      spacing={2}
      sx={[{
        alignItems: "center"
      }, activityOverviewHeaderStyles.filterContainer]}>
      <Grid size={isDeadlineView ? 5 : 3}>
        <Stack
          sx={[{
            justifyContent: "center"
          }, activityOverviewHeaderStyles.subjectFilter]}>
          <SubjectFilter setSubjectFilter={setSubjectFilter} />
        </Stack>
      </Grid>
      {!isDeadlineView && (
        <Grid size={2}>
          <ValidatorSelect
            label="Status"
            onChange={({ target }) => {
              setOpenOrDoneFilter(target.value);
            }}
            value={openOrDoneFilter}
            sx={activityOverviewHeaderStyles.filterSelect}
            fullWidth={false}
          >
            <MenuItem value={"open"}>Offen</MenuItem>
            <MenuItem value={"done"}>Erledigt</MenuItem>
          </ValidatorSelect>
        </Grid>
      )}
      <Grid size={2}>
        <ProductFilter productFilter={productFilter} setProductFilter={setProductFilter} />
      </Grid>
      <Grid size={2}>
        <ActivityTypeFilter
          activityTypeFilter={activityTypeFilter}
          setActivityTypeFilter={setActivityTypeFilter}
          isDeadlineView={isDeadlineView}
        />
      </Grid>
      <Grid size={3}>
        <OperationalEmployeeFilter
          userFilter={userFilter}
          setUserFilter={setUserFilter}
          agents={agents}
          isDeadlineView={isDeadlineView}
        />
      </Grid>
      <Grid size={9}>
        <Stack direction="row" spacing={2}>
          <ActivityFilterChip
            label={"Überfällig"}
            isActive={timespanFilter === "overdue"}
            onClick={() => setTimespanFilter("overdue")}
            amount={showAmount ? overdueTotal : undefined}
          />
          <ActivityFilterChip
            label={"Heute"}
            isActive={timespanFilter === "today"}
            onClick={() => setTimespanFilter("today")}
            amount={showAmount ? todayTotal : undefined}
          />
          {openOrDoneFilter !== "done" && (
            <ActivityFilterChip
              label={"Morgen"}
              isActive={timespanFilter === "tomorrow"}
              onClick={() => setTimespanFilter("tomorrow")}
            />
          )}
        </Stack>
      </Grid>
      <Grid size={3}>
        <DateRangeFilter timespanFilter={timespanFilter} setTimespanFilter={setTimespanFilter} />
      </Grid>
    </Grid>
  );
};
export default ActivityOverviewHeader;
